import React, { useEffect, useReducer, useState } from "react";
import { TextBox } from "devextreme-react/text-box";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import * as action from "../../actions/sa3";
import a3Reducer from "../../reducers/sa3";
import Button from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import { alert } from "devextreme/ui/dialog";
import { TextArea, ScrollView } from "devextreme-react";

const initialStates = {};

const ReasonForAction = (props: any) => {
  const [strategicObjective, setStrategicObjective] = useState("");
  const [problemStatement, setProblemStatement] = useState("");
  const [trigger, setTrigger] = useState("");
  const [done, setDone] = useState("");
  const [inScope, setInScope] = useState("");
  const [outOfScope, setOutOfScope] = useState("");
  const [state, dispatch] = useReducer(a3Reducer, initialStates);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    action.fetchData(dispatch, props.a3ID);
    AsyncCallHandler(
      NEXUS_CONST.FETCH_A3_DATA + props.a3ID,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res) {
        setStrategicObjective(res?.data?.strategicObjective);
        setProblemStatement(res?.data?.problemStatement);
        setTrigger(res?.data?.trigger);
        setDone(res?.data?.done);
        setInScope(res?.data?.inScope);
        setOutOfScope(res?.data?.outofScope);
        setIsDisabled(res?.data?.status === "Complete");
      }
    });
  }, []);

  const saveReasonForAction = () => {
    if (!strategicObjective) {
      alert("Please enter Strategic Objective", "Alert");
    } else if (!problemStatement) {
      alert("Please enter Problem Statement", "Alert");
    } else if (!trigger) {
      alert("Please enter Trigger", "Alert");
    } else if (!done) {
      alert("Please enter Done", "Alert");
    } else if (!inScope) {
      alert("Please enter In Scope", "Alert");
    } else if (!outOfScope) {
      alert("Please enter Out Of Scope", "Alert");
    } else {
      let formData = {
        a3ID: props.a3ID,
        tierID: props.tierId,
        strategicObjective: strategicObjective.trim(),
        problemStatement: problemStatement.trim(),
        trigger: trigger.trim(),
        done: done.trim(),
        inScope: inScope.trim(),
        outOfScope: outOfScope.trim(),
        lastSaved: "1",
        section:props.activeTab
      };
     
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_A3_DATA,
        NEXUS_CONST.POST,
        formData
      ).then((res) => {
        if (res) {
          notify("Reason For Action got saved successfully!", "success", 500);

          props.setStrategicA3Id(props.a3ID);

          props.handleA3Save();
          props.setisOpen("1");
          props.isDataSaved(2);
          props.isDataSaved(7);
          props.isDataSaved(9);
        }
      });
    }
    props.setisOpen("1");
  };

  const handleValueChange = (fieldName: string, value: any) => {
    switch (fieldName) {
      case "strategicObjective":
        setStrategicObjective(value);
        break;
      case "problemStatement":
        setProblemStatement(value);
        break;
      case "trigger":
        setTrigger(value);
        break;
      case "done":
        setDone(value);
        break;
      case "inScope":
        setInScope(value);
        break;
      case "outOfScope":
        setOutOfScope(value);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="title-section ">
        {" "}
        <h2 className="sps_title">Reason For Action</h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", marginTop: "3%" }}
            width={200}
            onClick={saveReasonForAction}
            disabled={isDisabled}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="420px" className="sps-box-s" >
      <div style={{marginRight: '20px'}}><div>
        <TextArea
          name="strategicObjective"
          label="Strategic Objective*"
          labelMode="floating"
          onValueChanged={(e) =>
            handleValueChange("strategicObjective", e.value)
          }
          value={strategicObjective}
          maxLength={4000}
        />
      </div>
      <div>
        <TextArea
          name="problemStatement"
          label="Problem Statement*"
          labelMode="floating"
          onValueChanged={(e) => handleValueChange("problemStatement", e.value)}
          value={problemStatement}
          maxLength={4000}
        />
      </div>
      <div>
        <TextBox
          name="trigger"
          label="Trigger*"
          labelMode="floating"
          onValueChanged={(e) => handleValueChange("trigger", e.value)}
          value={trigger}
          maxLength={20}
        />
      </div>
      <div>
        <TextBox
          name="done"
          label="Done*"
          labelMode="floating"
          onValueChanged={(e) => handleValueChange("done", e.value)}
          value={done}
          maxLength={20}
        />
      </div>
      <div>
        <TextArea
          name="inScope"
          label="In Scope*"
          labelMode="floating"
          onValueChanged={(e) => handleValueChange("inScope", e.value)}
          value={inScope}
          maxLength={500}
        />
      </div>
      <div>
        <TextArea
          name="outOfScope"
          label="Out Of Scope*"
          labelMode="floating"
          onValueChanged={(e) => handleValueChange("outOfScope", e.value)}
          value={outOfScope}
          maxLength={500}
        />
      </div>
      </div>
      </ScrollView>
    </>
  );
};

export default ReasonForAction;
